export function isBefore(el1: Node, el2: Node): boolean {
  let cur: Node | null
  if (el2.parentNode === el1.parentNode) {
    for (cur = el1.previousSibling; cur; cur = cur.previousSibling) {
      if (cur === el2) return true
    }
  }
  return false
}
